import { useUnit } from 'effector-react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { $addUserAccountsStore } from '@lib/store';
import type { GetAccountUsersResponse } from '@shared/api/rest/users';
import { Button, ErrorMessage, Modal, Multiselect } from '@shared/widgets';

interface IForm {
  managers: string[];
}
const DEFAULT_VALUES: IForm = { managers: [] };

interface IModalAddManager {
  isOpen: boolean;
  onClose: (confirm?: boolean) => void;
  data: GetAccountUsersResponse[];
  accountId: number;
}

export const AddManagerModal = (props: IModalAddManager) => {
  const addUserAccounts = useUnit($addUserAccountsStore.store);

  const { control, formState, handleSubmit, reset } = useForm<IForm>({ defaultValues: DEFAULT_VALUES });
  const { t } = useTranslation('account');

  const closeHandler = (confirm?: boolean) => {
    props.onClose(confirm);
    reset(DEFAULT_VALUES);
  };
  const submitHandler = async (data: IForm) => {
    await Promise.all(data.managers.map((manager) => $addUserAccountsStore.events.add({ userIds: manager, accountIds: [props.accountId] })));
    closeHandler(true);
  };

  return (
    <Modal isOpen={props.isOpen} onClose={() => closeHandler()} title={t('managers.modals.addManager.title')}>
      <form className='flex flex-col gap-8' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='managers'
          control={control}
          rules={{ required: t('errors.form.required', { ns: 'common' }) }}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <div>
              <Multiselect
                items={props.data.filter((user) => !user.locked).map((el) => ({ label: `${el.firstName} ${el.lastName}`, value: el.id }))}
                nullValue={{ isEnable: false, text: t('placeholders.selectManagers', { ns: 'common' }) }}
                required
                value={value}
                onChange={onChange}
              />
              <ErrorMessage text={error?.message} />
            </div>
          )}
        />
        <Button fullWidth color='primary' type='submit' disabled={addUserAccounts.loading || formState.isSubmitting}>
          {t('buttons.add', { ns: 'common' })}
        </Button>
      </form>
    </Modal>
  );
};
